
import { withGoogleMap } from 'react-google-maps';

import MapClass from './MapClass.jsx';

export default withGoogleMap(MapClass);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/MapSection/GoogleMap/GoogleMap.jsx